<template>
	<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M11.6443 12L17.25 6L11.6443 0L10.5 1.09251L14.9614 6L10.5 10.9075L11.6443 12Z" fill="currentColor"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M0.75 6.83329L15.75 6.83329L15.75 5.16663L0.75 5.16663L0.75 6.83329Z" fill="currentColor"/>
	</svg>
</template>